// src/pages/Careers/components/CareersFinalCTA.jsx
import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Flame } from "lucide-react";

const CareersFinalCTA = ({ onScrollToJobs }) => {
  return (
    <section className="py-12 md:py-14 bg-gray-50 text-gray-900 font-sans relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm font-medium border border-gray-300 rounded-full px-3.5 py-1 text-gray-700 bg-white mb-6 inline-flex items-center gap-2 shadow-sm">
            <Flame className="w-4 h-4 text-gray-900" />
            Shaping The Future Of Software
          </span>

          <h2 className="text-4xl md:text-6xl font-light leading-snug text-gray-900 mb-6">
            Ready to Build <br />
            <span className="font-normal">Something Real?</span>
          </h2>

          <p className="text-gray-600 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed font-normal">
            We're looking for curious minds, problem solvers, and builders who want to create technology that businesses actually use.
          </p>

          <button
            onClick={onScrollToJobs}
            className="px-8 py-3.5 rounded-lg font-medium text-base bg-gray-900 text-white hover:bg-gray-800 transition duration-300 shadow-xl inline-flex items-center gap-3 group"
          >
            <span>Join Our Team</span>
            <ArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default CareersFinalCTA;
